import { supabase } from './supabase';

const BUCKET = 'product-images';

/**
 * Upload a file to the public product-images bucket. Returns the public URL.
 * Path scheme: <itemId-or-"draft">/<random>-<original-filename>.
 *
 * RLS on the bucket only lets authenticated admins write — see migration
 * 0013_storage.sql. Reads are public so the URLs we save into items/main_image_url
 * resolve without auth.
 */
export async function uploadProductImage(file: File, itemId?: string): Promise<string> {
  if (!/^(image|video)\//.test(file.type)) {
    throw new Error('Only image and video files are accepted.');
  }
  if (file.size > 25 * 1024 * 1024) {
    throw new Error('File is too large (max 25MB).');
  }

  const folder = itemId || 'draft';
  const ext = file.name.split('.').pop()?.toLowerCase() ?? 'jpg';
  const safeBase = file.name
    .replace(/\.[^.]+$/, '')
    .replace(/[^a-z0-9-_]+/gi, '-')
    .toLowerCase()
    .slice(0, 40);
  const path = `${folder}/${Date.now()}-${Math.random().toString(36).slice(2, 8)}-${safeBase}.${ext}`;

  const { error } = await supabase.storage.from(BUCKET).upload(path, file, {
    contentType: file.type,
    cacheControl: '3600',
    upsert: false
  });
  if (error) throw new Error(error.message);

  const { data } = supabase.storage.from(BUCKET).getPublicUrl(path);
  return data.publicUrl;
}
